import * as React from "react";
import classnames from "classnames";
import { Link } from "@grandvisionhq/common";
import { StepForm, ConfiguratorStepTitleAndDescription } from "@grandvisionhq/configurator";
import { Icon } from "@grandvisionhq/icons";
import { ConfiguratorRadioTile } from "../../../../../../components/ConfiguratorRadioTile/components/ConfiguratorRadioTile/ConfiguratorRadioTile.js";
import { RxStepWrapper } from "../../../../RxStepWrapper/steps/components/RxStepWrapper/RxStepWrapper.js";
import DesktopStepLayout from "../../../../DesktopStepLayout/steps/components/DesktopStepLayout/DesktopStepLayout.js";
/* empty css                          */
const ProductSelectionStep = ({
  className,
  itemsList,
  selectedItemSku,
  readMoreLink,
  step,
  onChange,
  onSubmit
}) => {
  return /* @__PURE__ */ React.createElement(RxStepWrapper, { className: classnames("product-selection-step", className) }, /* @__PURE__ */ React.createElement(DesktopStepLayout, null, /* @__PURE__ */ React.createElement(StepForm, { onSubmit, className: "product-selection-step__wrapper" }, /* @__PURE__ */ React.createElement(ConfiguratorStepTitleAndDescription, { textAlignment: "left" }), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("product-selection-step__products", className),
      "data-t": "product-selection-step-products"
    },
    /* @__PURE__ */ React.createElement("fieldset", { className: "product-selection-step__list" }, itemsList.map((item) => /* @__PURE__ */ React.createElement(
      ConfiguratorRadioTile,
      {
        className: "product-selection-step__list-item",
        isSelected: selectedItemSku === item.sku,
        onChange,
        value: item.sku,
        key: item.sku,
        title: item.title,
        image: item.image_v2?.url,
        description: item.description,
        price: item.price,
        discountText: item.discountText,
        uspList: item.usps,
        tag: item.tags?.[0]?.value,
        step
      }
    ))),
    readMoreLink && /* @__PURE__ */ React.createElement(
      Link,
      {
        className: "product-selection-step__read-more",
        url: readMoreLink.url,
        openInNewWindow: readMoreLink.openInNewWindow
      },
      /* @__PURE__ */ React.createElement(Icon, { className: "product-selection-step__read-more-icon", name: "info" }),
      /* @__PURE__ */ React.createElement("span", { className: "product-selection-step__read-more-text" }, readMoreLink.label)
    )
  ))));
};
export {
  ProductSelectionStep
};
//# sourceMappingURL=ProductSelectionStep.js.map
